import { defineComponent as o, createBlock as n, openBlock as l, unref as a, mergeProps as c, withCtx as i, createElementVNode as p } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconArrowLeftInCircleFilled",
  __name: "IconArrowLeftInCircleFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const t = r;
    return (f, e) => (l(), n(a(m), c(t, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        p("path", { d: "M5.106 5.106c3.807-3.808 9.98-3.808 13.788 0 3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788m1.96 6.01a1.25 1.25 0 0 0 0 1.768l3.232 3.232a.75.75 0 0 0 1.06-1.06L9.054 12.75h7.19a.75.75 0 1 0 0-1.5h-7.19l2.305-2.306a.75.75 0 0 0-1.06-1.06l-3.233 3.232" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
